<template>
    <div>
      <div class="table-toolbar d-flex justify-content-between align-items-center mb-3">
        <div class="toolbar-left">
          <button
            class="btn btn-success btn-sm mr-2"
            @click="$root.$emit('toggle_modal', 'add_dataset')"
          >
            Tambah Knowledge
          </button>
        </div>
        <div class="toolbar-actions">
          <button
            class="btn btn-danger btn-sm mr-2"
            :disabled="selectedRows.length === 0 || table.isLoading"
            @click="deleteSelected"
          >
            Hapus Terpilih ({{ selectedRows.length }})
          </button>
          <button
            class="btn btn-outline-danger btn-sm"
            :disabled="table.total_records === 0 || table.isLoading"
            @click="deleteAll"
          >
            Hapus Semua
          </button>
        </div>
      </div>
      <vue-good-table
        ref="datasetTable"
        mode="remote"
        @on-page-change="onPageChange"
        @on-sort-change="onSortChange"
        @on-column-filter="onColumnFilter"
        @on-per-page-change="onPerPageChange"
        @on-selected-rows-change="onSelectedRowsChange"
        :totalRows="table.total_records"
        :isLoading.sync="table.isLoading"
        :pagination-options="{
          enabled: true,
          dropdownAllowAll: false,
          perPageDropdown: [10, 25, 50, 100],
        }"
        :selectOptions="selectOptions"
        :columns="table.columns"
        :rows="table.rows"
      >
        <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'q'">
                {{ cutString(props.row.q) }}
            </span>
            <span v-else-if="props.column.field == 'a'">
              {{ cutString(props.row.a) }}
            </span>
          <span v-else-if="props.column.field == 'action'">
            <a v-on:click="editDataset(props.row.id)">
              <a class="btn btn-primary text-white margin5">Detail</a>
            </a>
            <a
              v-on:click="deleteChatGPT(props.row.id)"
              class="btn btn-danger text-white margin5"
            >
              Hapus
            </a>
          </span>
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>
    </div>
  </template>
  
  <script>

  export default {
    props: ['id'],
    data() {
      return {
        selectedRows: [],
        selectOptions: {
          enabled: true,
          selectOnCheckboxOnly: true,
          selectionText: 'dataset dipilih',
          clearSelectionText: 'hapus pilihan',
          disableSelectInfo: false,
          selectAllByPage: true,
        },
        table: {
          total_records: 100,
          isLoading: true,
          columns: [
            {
              label: "Question",
              field: "q",
              filterOptions: {
                enabled: true,
              },
              sortable: false,
              width: "40%",
            },
            {
              label: "Answer",
              field: "a",
              filterOptions: {
                enabled: true,
              },
              sortable: false,
              width: "40%",
            },
            {
              label: "Action",
              field: "action",
              sortable: false,
              width: "20%",
            },
          ],
          rows: [],
          serverParams: {
            columnFilters: {},
            sort: [
              {
                field: "",
                type: "",
              },
            ],
            page: 1,
            limit: 10,
          },
        },
      };
    },
    mounted() {
      this.fn = () => {
        this.loadItems();
      }
      this.$root.$on("refresh_table", this.fn);
      this.loadItems();
    },
    beforeDestroy() {
      this.$root.$off("refresh_table", this.fn);
    },
    methods: {
      cutString(string){
                if(string == null || string == "") return ""
                
                if(string.length > 40){
                    string = string.slice(0, 40) + "..."
                }

                return string
            },
      async deleteChatGPT(id) {
        try {
          let response = await this.$store.dispatch("chatgpt_delete_dataset", {id: this.id, dataset_id: id});
          this.loadItems();
          this.$toast.success(response.data.message);

          this.$root.$emit("refresh_token", true);
        } catch (err) {
          this.$toast.error("Server error");
        }
      },
      updateParams(newProps) {
        this.table.serverParams = Object.assign(
          {},
          this.table.serverParams,
          newProps
        );
      },
      onPageChange(params) {
        this.updateParams({page: params.currentPage});
        this.loadItems();
      },
      onPerPageChange(params) {
        this.updateParams({limit: params.currentPerPage});
        this.loadItems();
      },
      onSortChange(params) {
        this.updateParams({
          sort: [
            {
              type: params.sortType,
              field: this.table.columns[params.columnIndex].field,
            },
          ],
        });
        this.loadItems();
      },
      onColumnFilter(params) {
        this.updateParams(params);
        this.loadItems();
      },
      onSelectedRowsChange(params) {
        this.selectedRows = params.selectedRows || [];
      },
      async deleteSelected() {
        if (this.selectedRows.length === 0) return;
        if (!confirm(`Yakin ingin menghapus ${this.selectedRows.length} dataset terpilih?`)) {
          return;
        }
        try {
          const ids = this.selectedRows.map(row => row.id);
          const response = await this.$store.dispatch('chatgpt_dataset_bulk_delete', {
            id: this.id,
            dataset_ids: ids,
          });
          this.$toast.success(response.data.message || 'Berhasil menghapus dataset terpilih');
          this.selectedRows = [];
          this.loadItems();
        } catch (err) {
          this.$toast.error(err.response?.data?.message || 'Server error');
        }
      },
      async deleteAll() {
        if (!confirm('Yakin ingin menghapus SEMUA dataset?')) {
          return;
        }
        try {
          const response = await this.$store.dispatch('chatgpt_dataset_delete_all', {
            id: this.id,
          });
          this.$toast.success(response.data.message || 'Berhasil menghapus semua dataset');
          this.selectedRows = [];
          this.loadItems();
        } catch (err) {
          this.$toast.error(err.response?.data?.message || 'Server error');
        }
      },
      async loadItems() {
        this.table.isLoading = true
        try {
          let response = await this.getFromServer(this.table.serverParams);
          this.table.total_records = response.data.data.total_records;
          this.table.rows = response.data.data.chatgpt;

        //   for (let i = 0; i < this.table.rows.length; i++) {
        //     this.table.rows[i].count_device = JSON.parse(this.table.rows[i].device).length ?? 0
        //   }
        } catch (err) {
          this.$toast.error("Too many request");
        }
        this.table.isLoading = false
      },
      async getFromServer(param) {
        param.chatgpt_id = this.id
        return await this.$store.dispatch("chatgpt_dataset_list", param);
      },
      async editDataset(id) {
        this.$root.$emit("toggle_modal", "edit_dataset")
        this.$root.$emit("edit_dataset", id)
      },
    },
  };
  </script>
  
  <style scoped>
  .margin5 {
    margin: 5px;
  }

  .table-toolbar {
    padding: 4px 0 8px;
  }

  .toolbar-left {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
  }

  .toolbar-actions {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
  }

  @media (max-width: 768px) {
    .table-toolbar {
      justify-content: flex-start !important;
    }
  }
  </style>
  